import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface IPaymentTypeInfo extends IBaseElementProps {
	monerisLogo?: IImage;
	monerisText?: string;
	paypalLogo?: IImage;
	paypalText?: string;
}

export interface IDonorToolPaymentTypeInfoProps extends IBaseElementProps {
	children?: any;
	paymentTypeInfo?: IPaymentTypeInfo;
}

const DonorToolPaymentTypeInfo: React.FC<IDonorToolPaymentTypeInfoProps> = ({
	children,
	className,
	classNames = [],
	paymentTypeInfo,
}) => (
	<>
		<div className="moneris-info-container__logo">
			{paymentTypeInfo?.monerisLogo && <Image className="img-fluid" {...paymentTypeInfo.monerisLogo} />}
		</div>
		<p className="moneris-info-container__text" dangerouslySetInnerHTML={ {__html: paymentTypeInfo?.monerisText } }></p>
		<div className="paypal-info-container__logo">
			{paymentTypeInfo?.paypalLogo && <Image className="img-fluid" {...paymentTypeInfo.paypalLogo} />}
		</div>
		<p className="moneris-info-container__text" dangerouslySetInnerHTML={ {__html: paymentTypeInfo?.paypalText } }></p>
	</>
);

export default DonorToolPaymentTypeInfo;
